// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.controls_zbzrq {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  opacity: 0;
  transition: opacity 0.5s;
  pointer-events: none;
}

.visible_n3EDN {
  opacity: 1;
  pointer-events: all;
}

.overlay_Emc7S {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}

.poster_VJBwk {
  font-size: calc(min(25cqh, 25cqw)) !important;
  cursor: pointer;
}

.loader_rLRNU {
  font-size: calc(min(10cqh, 10cqw)) !important;
}

.error_V1Lmv {
  align-items: baseline;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-video/lib/player/shared/Controls.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".controls {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 999;\n  opacity: 0;\n  transition: opacity 0.5s;\n  pointer-events: none;\n}\n\n.visible {\n  opacity: 1;\n  pointer-events: all;\n}\n\n.overlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 9999;\n}\n\n.poster {\n  font-size: calc(min(25cqh, 25cqw)) !important;\n  cursor: pointer;\n}\n\n.loader {\n  font-size: calc(min(10cqh, 10cqw)) !important;\n}\n\n.error {\n  align-items: baseline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"controls": `controls_zbzrq`,
	"visible": `visible_n3EDN`,
	"overlay": `overlay_Emc7S`,
	"poster": `poster_VJBwk`,
	"loader": `loader_rLRNU`,
	"error": `error_V1Lmv`
};
export default ___CSS_LOADER_EXPORT___;
